import { httpV1 as http } from '../api';

/** Notificações in-app do usuário logado (B2B-91). */

export async function list(params) {
  return http.get('/backoffice/notifications', { params });
}

export async function unreadCount() {
  return http.get('/backoffice/notifications/unread-count');
}

export async function markAsRead(id) {
  return http.patch(`/backoffice/notifications/${id}/read`);
}

export async function markAsUnread(id) {
  return http.patch(`/backoffice/notifications/${id}/unread`);
}

export async function markAllAsRead() {
  return http.patch('/backoffice/notifications/read-all');
}

export async function markAllAsUnread() {
  return http.patch('/backoffice/notifications/unread-all');
}

export async function remove(id) {
  return http.delete(`/backoffice/notifications/${id}`);
}

export async function removeAll() {
  return http.delete('/backoffice/notifications/all');
}

/* --- Web Push (página fechada) --- */

export async function pushVapidKey() {
  return http.get('/backoffice/notifications/push/vapid');
}

export async function pushSubscribe(subscription, deviceLabel) {
  return http.post('/backoffice/notifications/push/subscribe', {
    subscription,
    device_label: deviceLabel,
  });
}

export async function pushDevices() {
  return http.get('/backoffice/notifications/push/devices');
}

export async function pushRevoke(id) {
  return http.delete(`/backoffice/notifications/push/devices/${id}`);
}
